import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { useNavigate } from 'react-router-dom'
import { Container, InputsContainer, InputContainer } from './../new/styled'
import Input from 'views/components/UI/TextInput'
import DatePicker from 'views/components/UI/Datepicker'
import { Button } from 'views/components/UI/Buttons'
import { MainLayout } from 'views/layouts'
import { BtnGoBack, ContainerRow } from 'views/components/Modal/styled'

import { generalDataSelector } from 'ducks/auth'
import { fetchGetInventoryAction, updateInventory } from './services/services-components'
import { useNotification } from 'lib/context/notification.context'

function Index() {
  const navigate = useNavigate()
  const { getWarning, getSuccess } = useNotification()
  const { data } = useSelector(generalDataSelector)
  const [companyName, setCompanyName] = useState('')
  const [expirationDate, setExpirationDate] = useState('')
  const [credits, setCredits] = useState('')
  const [params, setParams] = useState<any>({})
  const [idCompany, setIdCompany] = useState<number | null>(null)

  dayjs.extend(utc)

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search)
    setParams(Object.fromEntries(searchParams))
  }, [data])

  useEffect(() => {
    if (Object.keys(params).length > 0) {
      const companyId = parseInt(params.companyId)
      setIdCompany(companyId)
    }
  }, [params])

  useEffect(() => {
    const handleFetchError = () => {
      getWarning('Error al cargar el inventario')
    }

    if (!idCompany) return
    fetchGetInventoryAction(Number(idCompany))
      .then((response) => {
        setCompanyName(response?.name ?? '')
        setExpirationDate(response?.expiration_date ?? '')
        setCredits(response?.credits?.toString() ?? '')
      })
      .catch(handleFetchError)
  }, [idCompany, getWarning])

  const handleUpdate = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    if (!idCompany) return

    try {
      const bodyUpdate = {
        name: companyName,
        credits: Number(credits),
        expiration_date: dayjs.utc(expirationDate).format(),
      }

      const response = await updateInventory(bodyUpdate, Number(idCompany))

      if (response.status === 'success') {
        getSuccess('Inventario actualizado correctamente')
        navigate(-1)
      } else {
        getWarning('Error al actualizar el inventario')
      }
    } catch (error) {
      getWarning('Error al actualizar el inventario')
    }
  }

  return (
    <MainLayout>
      <form onSubmit={handleUpdate}>
        <Container>
          <h1>Editar inventario</h1>
          <InputsContainer>
            <InputContainer>
              <Input
                type="text"
                name="name"
                label="Nombre"
                placeholder="Nombre del inventario"
                onChange={(e) => setCompanyName(e.target.value)}
                value={companyName}
              />
            </InputContainer>
            <InputContainer>
              <Input
                type="number"
                name="credits"
                label="Cantidad de pruebas"
                onChange={(e) => setCredits(e.target.value)}
                value={credits}
              />
            </InputContainer>
            <InputContainer>
              <DatePicker
                useISO8601={true}
                label="Fecha de vencimiento"
                value={expirationDate}
                onChange={(date) => setExpirationDate(date)}
                format="DD/MM/YYYY"
              />
            </InputContainer>
          </InputsContainer>
          <ContainerRow>
            <BtnGoBack onClick={() => navigate(-1)}>Cancelar</BtnGoBack>
            <Button type="submit">Guardar</Button>
          </ContainerRow>
        </Container>
      </form>
    </MainLayout>
  )
}

export default Index
